import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=69d0853c&scoped=true"
import script from "./videoIframe.vue?vue&type=script&lang=js"
export * from "./videoIframe.vue?vue&type=script&lang=js"
import style0 from "./videoIframe.vue?vue&type=style&index=0&id=69d0853c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d0853c",
  null
  
)

export default component.exports